import type { AppointmentStatus } from '@bb/domain/dist/types';
import { AppointmentType } from '@bb/domain/dist/types';

import type { StatusMenuItem } from './types';

export const getStatusMenuItems = ({
  isBuyer,
}: {
  isBuyer: boolean;
}): StatusMenuItem[] => {
  const listingItems: StatusMenuItem[] = [
    {
      label: 'New',
      key: 'new',
    },
    { label: 'Attempted', key: 'attempted' },
  ];

  return [
    {
      label: 'Awaiting Approval',
      key: 'pending',
    },
    ...(isBuyer ? [] : listingItems),
    {
      label: 'Confirmed',
      key: 'confirm',
    },
    {
      label: 'Denied',
      key: 'deny',
    },
    {
      label: 'Cancelled',
      key: 'cancel',
    },
    {
      label: 'Time Change',
      key: 'time_change',
    },
    {
      label: 'Time Passed',
      key: 'time_passed',
    },
  ];
};

export const TIME_CHANGE_STATUSES: AppointmentStatus[] = [
  'time_change',
  'suggested_time_change',
];

export const DEFAULT_STATUS_FILTERS: AppointmentStatus[] = [
  'new',
  'deny',
  'attempted',
  'cancel',
  'confirm',
  'time_change',
  'time_passed',
];

export const ES_DELAY = {
  DEFAULT: 5500,
  LARGE: 6500,
  GLACIAL: 8000,
};
